import { useState, useEffect } from "react";
import { BREAKPOINTS } from "../lib/constants";

// Tracks a max-width media query so components can render a structurally
// different (not just reflowed) view for narrow viewports. Listens for
// changes rather than reading once so rotating a tablet or resizing a
// desktop window updates the result live.
export function useIsMobile(breakpointPx = BREAKPOINTS.mobile) {
  const query = `(max-width: ${breakpointPx}px)`;
  const [isMobile, setIsMobile] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return isMobile;
}
